import cx from 'classnames';

import { Image } from '~/components/Image';
import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import type { Publication } from '~/interfaces/publication';

interface Props {
  publication: Publication;
  className?: string;
}

const Logo = ({ publication, className }: Props) => {
  const { classes } = useWebThemeContext();

  return (
    <div className={cx(classes.radius, classes.shadow, 'overflow-hidden', className)}>
      {publication.logo.thumb.url && (
        <Image src={publication.logo.thumb.url} alt={publication.name} maxWidth={200} aspectRatio="square" />
      )}
    </div>
  );
};

export default Logo;
